import { Paginated } from "./utils";

export enum TemplateCategory {
  MARKETING = "MARKETING",
  BRANDING = "BRANDING",
  UI_UX = "UI_UX",
  PRINT = "PRINT",
  PACKAGING = "PACKAGING",
  MERCHANDISE = "MERCHANDISE",
  VIDEO = "VIDEO",
  SCHULUNG = "SCHULUNG",
}

export interface TemplateListPaginatedResponseDtoWithFeaturedAndEntities {
  featuredTemplates: TemplateFeaturedListResponseDto[];
  templates: Paginated<TemplateListResponseDto>;
  filterSelectableEntities: TemplateFilterSelectableEntitiesResponseDto;
}

export interface TemplateFeaturedListResponseDto {
  _id: string;
  title: string;
  featured: boolean;
  imageUrl?: string;
}

export interface TemplateListResponseDto {
  _id: string;
  title: string;
  templateCategory: TemplateCategory;
  description: string;
  featured: boolean;
  imageUrl?: string;
}

export interface TemplateFilterSelectableEntitiesResponseDto {
  categoryFilter: TemplateCategory[];
}

export interface TemplateMockResponseDto {
  mockTitle: string;
  mockDescription: string;
}

export interface CreateTemplateRequestDto {
  title: string;
  templateCategory: TemplateCategory;
  description: string;
  featured: boolean;
  mockTitle: string;
  mockDescription: string;
}

export interface UpdateTemplateRequestDto {
  title?: string;
  templateCategory?: TemplateCategory;
  description?: string;
  featured?: boolean;
  mockTitle?: string;
  mockDescription?: string;
}

export interface TemplateDetailsResponseDto {
  _id: string;
  title: string;
  templateCategory: TemplateCategory;
  description: string;
  featured: boolean;
  imagePath?: string;
  imageUrl?: string;
  mockTitle: string;
  mockDescription: string;
}

export interface TemplateCreationEntitiesResponseDto {
  categories: TemplateCategory[];
}
